<template>
	<sequential-entrance fromLeft>
	<div class="card cardptpr mb-4" :onclick="this.url ? 'window.open(\'' + this.url + '\')' : ''">
		<div class="card-header cardptpr p-3 pb-0 pt-0" v-if="this.title">
			<H6 :class="warning ? 'text-warning' : ''">{{this.title}}</H6>
		</div>
		<div class="card-body p-3">
			<ul class="list-group" v-if="this.data.length > 0">
				<li class="list-group-item border-0 d-flex justify-content-between ps-0 pe-0 mb-0 border-radius-lg" 
						v-for="(item, index) in this.data" :key="index">
					<div class="d-flex flex-column">
						<span class="d-flex flex-row justify-content-end text-sm">{{prefix}} {{item[itemcol]}}</span>
					</div>
					<div class="d-flex flex-column" v-if="valuecol"> 
						<span class="d-flex flex-row justify-content-end text-sm">{{curr}} {{ (div ? item[valuecol] / div : item[valuecol]) * 1 | formatNum}} {{unit}}</span>
					</div>
					<div class="d-flex flex-column" v-if="textvaluecol"> 
						<span class="d-flex flex-row justify-content-end text-sm">{{item[textvaluecol]}}</span>
					</div>
				</li>
			</ul>
			<div v-else>
				<div class="d-flex flex-row justify-content-center align-items-center">
					No Data
				</div>
			</div>
		</div>
	</div>
	</sequential-entrance>
</template>

<script>
export default{
	props:["data", "title", "itemcol", "valuecol", "textvaluecol", "warning", "url", "prefix", "curr", "unit", "div"],
	components:{
	},
    mounted(){
    },
    methods:{
	}
}

</script>